import { buildPartialSaveUrl } from '@/shared/configs/apiConfig.js'

export default {
  postUrl(payload) {
    return buildPartialSaveUrl({
      userId: 'rapidoo-data-mock',
      mergeTableKeys: 'balances',
    })
  },

  format(payload) {
    return {
      appInfo: {
        balances: {
          statusCode: 200,
          data: payload,
        },
      },
    }
  },

  parse(raw = {}, payload = {}) {
    if (raw?.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 500,
        message: raw?.message || 'Erreur lors de la mise à jour des soldes',
        success: false,
      }
    }

    return {
      statusCode: 200,
      message: 'Soldes mis à jour avec succès',
      success: true,
      data: raw?.data,
    }
  },
}
